<template>
    <div class="container">
        <div v-for="optionGroup in optionGroups" class="row" :key="optionGroup.id">
            <div class="col">
                <h3 class="mb-2 mt-5 text-center group-header">{{ optionGroup.name }}</h3>
                <div class="d-flex flex-wrap align-items-start justify-content-start multiselect-container">
                    <div @click.prevent="selectItem(optionGroup, option)" v-for="option in optionGroup.options" :key="option.id" class="option">
                        <template v-if="option.type === 'add'">
                            <img class="radio-button" src="../assets/add-button.svg">
                        </template>
                        <template v-else-if="option.type === 'edit'">
                            <img class="radio-button" src="../assets/edit-button.svg">
                        </template>
                        <template v-else>
                            <img v-if="isItemSelected(optionGroup, option)" class="radio-button" src="../assets/radio-selected.svg">
                            <img v-if="!isItemSelected(optionGroup, option)" class="radio-button" src="../assets/radio-unselected.svg">
                        </template>
                        <div class="title" :class="classForTitle(option.name)">{{ option.name }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'MultiselectGroupedList',

    props: {
      optionGroups: {
        type: Array,
        required: true
      },
      isSelected: {
        type: Function,
        required: false
      }
    },

    data () {
      return {
        isSaving: false
      }
    },

    methods: {
      classForTitle (title) {
        if (!title) {
          return ''
        }

        if (screen.width <= 375 || title.length >= 20) {
          return 'two-line'
        }

        return ''
      },

      selectItem (group, item) {
        this.$emit('optionSelected', group, item)
      },

      isItemSelected (group, item) {
        if (this.isSelected) {
          return this.isSelected(group, item)
        } else {
          return item.selected
        }
      }
    }
  }
</script>

<style scoped>
    .group-header {
        color: rgba(23,56,96,1.0);
        font-weight: bolder;
    }

    .option {
        box-shadow: 2px 2px 5px darkgray;
        margin: .25em;
        border-radius: 5px;
        background-color: white;
        width: 400px;
        min-height: 72px;
        max-height: 100%;
        border: 2px solid transparent;
        clear: both;
        vertical-align: center;
    }

    .title {
        margin-left: 8px;
        display: inline-block;
        font-size: 20px;
        color: rgba(23,56,96,1.0);
        font-weight: bold;
        padding: .25em;
        max-width: 310px;
        /* max-height: 50px; */
        float: left;
        padding-top: 20px;
        overflow: hidden;
        /* These are technically the same, but use both */
        overflow-wrap: break-word;
        word-wrap: break-word;

        -ms-word-break: break-all;
        /* Instead use this non-standard one: */
        word-break: break-word;

        /* Adds a hyphen where the word breaks, if supported (No Blink) */
        -ms-hyphens: auto;
        -moz-hyphens: auto;
        -webkit-hyphens: auto;
        hyphens: auto;
    }

    @media (max-width: 320px) {
        .title {
            width: 180px;
        }
    }

    @media (min-width: 321px) and (max-width: 375px) {
        .title {
            width: 220px;
        }
    }

    @media (min-width: 376px) and (max-width: 416px) {
        .title {
            width: 230px;
        }
    }

    .title.two-line {
        padding-top: 4px;
        max-height: 100%;
    }

    .option img {
        margin-top: 8px;
        margin-left: 8px;
        height: 52px;
        width: 52px;
        display: inline-block;
        float: left;
    }

    @media (min-width: 1061px) {
        .option:HOVER {
            cursor: pointer;
            border: 2px solid rgba(255,62,3,1.0);
        }
    }

    .multiselect-container {
        max-width: 820px;
        margin: auto;
    }

    @media (max-width: 1060px) {
        .multiselect-container {
            max-width: 400px;
        }
    }
</style>
